<div class="offer-details-container">
    <div class="nova-toolbar__pre-header space-between items-center">
        <div class="flex-row justify-start items-center">
            <div class="title">Offer Details - {{ offerDetails?.candidateName }}</div>
        </div>
        <div class="button-actions">
            <button
                mat-flat-button
                type="submit"
                [disabled]="detailsFormGroup.invalid || disableSubmitAndCancel || (isJobExtension && !isJobApproved)"
                color="primary"
                (click)="createOffer()"
                data-qa-id="CreateOfferButton"
                >Create Offer</button
            >
            <button
                mat-stroked-button
                type="button"
                color="secondary"
                (click)="cancelCreateOffer()"
                [disabled]="disableSubmitAndCancel"
                >Cancel</button
            >
        </div>
    </div>
    <ng-container>
        <nova-banner
            *ngIf="validateCandidateProfessionJobs"
            bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    <nova-banner
        *ngIf="isJobExtension && !isJobApproved"
        bannerType="alert"
        bannerMessage="Offer cannot be created because this job has not been approved by the client.">
    </nova-banner>
    @if (!offerOptimizations()) {
        <div class="offer-details-content flex-row-wrap justify-start gap-16">
            <mat-card class="info">
                <mat-card-content>
                    <ng-template #loading>
                        <div class="progress">
                            <mat-progress-spinner
                                mode="indeterminate"
                                diameter="96"></mat-progress-spinner>
                        </div>
                    </ng-template>
                    <form
                        [formGroup]="detailsFormGroup"
                        *ngIf="offerDetails; else loading">
                        <table
                            class="offer-info-table"
                            aria-label="Submittal Table">
                            <tbody>
                                <tr class="hidden">
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Candidate *</span></td>
                                    <td>
                                        <span data-qa-id="CandidateView">{{ offerDetails.candidateName }}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="offerType === offerTypes.Agency">
                                    <td><span class="label-text">Vendor</span></td>
                                    <td>
                                        <span data-qa-id="VendorNameView">{{ offerDetails?.vendorName }}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="offerType === offerTypes.Agency">
                                    <td><span class="label-text">Vendor Contact</span></td>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select
                                                formControlName="vendorContactId"
                                                data-qa-id="VendorContactSelect">
                                                <mat-option
                                                    *ngFor="let option of vendorLookups?.contacts"
                                                    [value]="option.id"
                                                    >{{ option.name }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Contract Type</span></td>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select
                                                formControlName="contractTypeId"
                                                data-qa-id="ContractTypeSelect">
                                                <mat-option
                                                    *ngFor="let option of lookups?.contracts"
                                                    [value]="option.id"
                                                    >{{ option.code }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Position Type</span></td>
                                    <td>
                                        <span>{{ offerDetails?.positionType }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Job ID</span></td>
                                    <td>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="jobId"
                                                [matAutocomplete]="jobIdAuto"
                                                data-qa-id="JobIdInput"
                                                (change)="jobIdSelection($event)" />
                                            <mat-autocomplete
                                                #jobIdAuto="matAutocomplete"
                                                [displayWith]="displayJobIds"
                                                (optionSelected)="jobIdSelection($event)">
                                                <mat-option
                                                    *ngFor="let job of filteredJobIdOptions | async"
                                                    [value]="job"
                                                    >{{ job }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Facility</span></td>
                                    <td>
                                        <span data-qa-id="FacilityView">{{ offerDetails?.facilityName }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">AM</span></td>
                                    <td>
                                        <span data-qa-id="AccountManagerNameView">{{
                                            offerDetails?.accountManagerName
                                        }}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="offerType === offerTypes.Direct">
                                    <td
                                        ><span
                                            class="label-text"
                                            data-qa-id="MarginIdLabel"
                                            >Margin ID</span
                                        ></td
                                    >
                                    <td>
                                        <span></span>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <ng-container>
                                    <tr>
                                        <td><span class="label-text">Candidate Profession</span></td>
                                        <td>
                                            <span data-qa-id="ProfessionView">{{
                                                detailsFormGroup?.controls?.candidateProfessionName?.value
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr><td colspan="2"></td> </tr>
                                    <tr>
                                        <td><span class="label-text">Job Profession</span></td>
                                        <td>
                                            <span data-qa-id="ProfessionView">{{
                                                detailsFormGroup?.controls?.professionName?.value
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr
                                        *ngIf="offerDetails?.isRemoteBooking !== null"
                                        data-qa-id="job-details-work-model">
                                        <td><span class="label-text">Work Model</span></td>
                                        <td>
                                            <mat-radio-group
                                                formControlName="isRemoteBooking"
                                                name="isRemoteBooking"
                                                data-qa-id="job-details-work-model-radio">
                                                <mat-radio-button
                                                    class="mx-2"
                                                    [value]="false"
                                                    >Onsite</mat-radio-button
                                                >
                                                <mat-radio-button
                                                    class="mx-2"
                                                    [value]="true"
                                                    >Remote</mat-radio-button
                                                >
                                            </mat-radio-group>
                                        </td>
                                    </tr>
                                    <tr
                                        *ngIf="offerDetails?.isPatientFacing !== null"
                                        data-qa-id="job-details-work-type">
                                        <td><span class="label-text">Work Type</span></td>
                                        <td>
                                            <span>{{
                                                offerDetails?.isPatientFacing ? 'Patient-Facing' : 'Non-Patient-Facing'
                                            }}</span>
                                        </td>
                                    </tr>
                                    <ng-container>
                                        <tr *ngIf="validateCandidateProfessionJobs">
                                            <td colspan="2">
                                                <mat-error
                                                    >Clinician's profession must match the job's profession. Please
                                                    review and update before creating an Offer.</mat-error
                                                >
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <tr>
                                        <td><span class="label-text">Job Specialty</span></td>
                                        <td>
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width extended-field">
                                                <mat-select
                                                    formControlName="expertiseId"
                                                    (selectionChange)="checkRateUpdateFields('Expertise')"
                                                    [disabled]="!detailsFormGroup?.controls?.professionId?.value"
                                                    data-qa-id="ExpertiseSelect">
                                                    <mat-option
                                                        *ngFor="let option of expertise"
                                                        [value]="option.id"
                                                        >{{ option.name }}</mat-option
                                                    >
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr><td colspan="2"></td></tr>
                                <ng-container>
                                    <tr>
                                        <td>
                                            <span class="label-text">Contract Length</span>
                                        </td>
                                        <td>
                                            <div>
                                                <mat-form-field class="contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('weeksLengthChanged')"
                                                        formControlName="contractLength" />
                                                    <mat-error>Please enter valid Weeks Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Weeks</span>
                                            </div>
                                            <div>
                                                <mat-form-field class="contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('daysLengthChanged')"
                                                        formControlName="contractLengthDays" />
                                                    <mat-error>Please enter valid Days Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Days</span>
                                                <mat-icon
                                                    *ngIf="contractLengthDaysApprovalRequired"
                                                    class="info-icon"
                                                    [matTooltip]="contractLengthDaysInfoMessage"
                                                    >info</mat-icon
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Start</span></td>
                                        <td>
                                            <mat-form-field>
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    formControlName="startDate"
                                                    (dateChange)="calculateContractDates('startDateChanged')"
                                                    data-qa-id="StartDateInput" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error *ngIf="detailsFormGroup.controls['startDate'].invalid"
                                                    >Please enter valid start date.</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">End</span></td>
                                        <td>
                                            <mat-form-field>
                                                <input
                                                    matInput
                                                    [matDatepicker]="endPicker"
                                                    formControlName="endDate"
                                                    [min]="minEndDate"
                                                    (dateChange)="calculateContractDates('endDateChanged')"
                                                    data-qa-id="EndDateInput" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="endPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #endPicker></mat-datepicker>
                                                <mat-error *ngIf="detailsFormGroup.controls['endDate'].invalid"
                                                    >Please enter valid end date.</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container>
                                    <tr>
                                        <td
                                            ><span class="label-text">Shift Type <span>*</span></span></td
                                        >
                                        <td>
                                            <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                <mat-select
                                                    formControlName="shiftTypeId"
                                                    data-qa-id="ShiftTypeSelect">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTypes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTypeId', 'required')"
                                                    >Shift Type is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td
                                            ><span class="label-text"># of Shifts <span>*</span></span></td
                                        >
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shifts"
                                                    data-qa-id="NumberShiftsSelect"
                                                    (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shifts', 'required')"
                                                    ># of Shifts is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shiftsAlt"
                                                    data-qa-id="NumberShiftsAltSelect">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftsAlt', 'required')"
                                                    ># of Alt Shifts is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td
                                            ><span class="label-text">Shift Length <span>*</span></span></td
                                        >
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <div class="tdSplit">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hours"
                                                        (selectionChange)="checkRateUpdateFields('Shift Length')"
                                                        data-qa-id="ShiftLengthSelect">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hours', 'required')"
                                                        >Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hoursAlt"
                                                        (selectionChange)="onShiftLengthAltSelected()"
                                                        data-qa-id="ShiftAltLengthSelect">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hoursAlt', 'required')"
                                                        >Alt Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Time of Day <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shiftTimeOfDayId"
                                                    (selectionChange)="checkRateUpdateFields('Shift Time of Day')"
                                                    data-qa-id="ShiftTimeSelect">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')"
                                                    >Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift || isRotatingShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shiftAltTimeOfDayId"
                                                    data-qa-id="ShiftAltTimeSelect">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')"
                                                    >Alt Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Time</span>
                                            <span class="under-label">Optional</span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <div class="tdSplit">
                                                <table
                                                    class="inner-table"
                                                    aria-label="shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeStart"
                                                                (valueChange)="onTimeStartChanged($event)"
                                                                format="HH:mm"
                                                                data-qa-id="ShiftStartTimepicker">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeEnd"
                                                                (valueChange)="onTimeEndChanged($event)"
                                                                format="HH:mm"
                                                                data-qa-id="ShiftEndTimepicker">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift || isRotatingShift">
                                                <table
                                                    class="inner-table"
                                                    aria-label="alt shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeStart"
                                                                (valueChange)="onAltTimeStartChanged($event)"
                                                                format="HH:mm"
                                                                data-qa-id="ShiftAltStartTimepicker">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeEnd"
                                                                (valueChange)="onAltTimeEndChanged($event)"
                                                                format="HH:mm"
                                                                data-qa-id="ShiftAltEndTimepicker">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Shift Details</span></td>
                                        <td>
                                            <textarea
                                                formControlName="shiftDetails"
                                                class="other-notes-textarea"
                                                data-qa-id="ShiftDetailsText"></textarea>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">RTO</span></td>
                                    <td>
                                        <mat-checkbox
                                            formControlName="hasRequestedTimeOff"
                                            data-qa-id="hasRequestedTimeOffCheckbox"></mat-checkbox>
                                    </td>
                                </tr>

                                <ng-container *ngIf="detailsFormGroup.controls.hasRequestedTimeOff.value">
                                    <tr>
                                        <td><span class="label-text">RTO Dates</span></td>
                                        <td>
                                            <div class="rto-container">
                                                <div class="date-input-container">
                                                    <div class="days">
                                                        <span>{{ daysRequested }}</span>
                                                    </div>
                                                    <button
                                                        class="rto-btn"
                                                        mat-icon-button
                                                        [matMenuTriggerFor]="appMenu">
                                                        <mat-icon>event</mat-icon>
                                                    </button>
                                                </div>

                                                <mat-menu
                                                    #appMenu="matMenu"
                                                    class="drop-calendar">
                                                    <div (click)="$event.stopPropagation()">
                                                        <mat-calendar
                                                            #calendar
                                                            class="mat-calendar"
                                                            [dateClass]="dateClass()"
                                                            [maxDate]="maxDate"
                                                            [minDate]="minDate"
                                                            (selectedChange)="dateChanged($event)"></mat-calendar>
                                                    </div>
                                                </mat-menu>

                                                <a
                                                    class="nova-link rto-clear__btn"
                                                    [class.disabled]="daysSelected.length ? false : true"
                                                    (click)="clearDates()"
                                                    #clearCalendarTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="appMenu"
                                                    >Clear</a
                                                >
                                            </div>
                                            <div class="offer-rto-warning">
                                                <nova-rto-warning-message [enabled]="showRTOAlertOnStartEndDates">
                                                </nova-rto-warning-message>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">RTO Approval</span></td>
                                        <ng-container>
                                            <td>
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="rtoApprovalStatus"
                                                        data-qa-id="RTOApprovalStatusSelect">
                                                        <mat-option [value]="1">Approved</mat-option>
                                                        <mat-option [value]="2">Pending Approval</mat-option>
                                                        <mat-option [value]="3">Not Approved</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Facility Rate</span></td>
                                    <td>
                                        <span class="label-text mr">$</span>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="facilityRate"
                                                (keyup)="updateVendorRate()"
                                                data-qa-id="FacilityRateInput"
                                                (change)="calculateContractDates('facilityRateChanged')" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Doughboy</span></td>
                                    <td>
                                        <nova-recruiter-bonus
                                            [bonus]="offerDetails?.recruiterBonus"
                                            data-qa-id="DoughboyText"></nova-recruiter-bonus>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Aya Paid Bonus</span></td>
                                    <td>
                                        <span class="label-text mr">$</span>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="ayaPaidBonus"
                                                (keydown)="validateInput($event)"
                                                data-qa-id="ayaPaidBonusInput"
                                                min="0"
                                                max="999999.99" />
                                            <mat-error>Please enter valid bonus amount.</mat-error>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <tr *ngIf="offerType === offerTypes.Agency">
                                    <td><span class="label-text">Vendor Rate</span></td>
                                    <td>
                                        <span class="label-text mr">$</span>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="vendorRate"
                                                data-qa-id="VendorRateInput" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Other Details</span></td>
                                    <td>
                                        <div class="flex-col flex-1">
                                            <mat-form-field>
                                                <textarea
                                                    matInput
                                                    formControlName="otherDetails"
                                                    class="other-notes-textarea"
                                                    data-qa-id="OtherDetailsText" maxlength="1500"></textarea>
                                                <mat-hint align="end">{{ detailsFormGroup.controls.otherDetails.value?.length ?? 0 }}/1500 characters</mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </mat-card-content>
            </mat-card>
            <mat-card class="notes"> </mat-card>
        </div>
    } @else {
        @if (offerDetails) {
            <div class="main-container">
                <div class="left-container">
                    <form
                        [formGroup]="detailsFormGroup"
                        class="offer-details--form">
                        @if (offerType !== offerTypes.Agency) {
                            <div class="details__banner mb-4">
                                <mat-icon
                                    aria-hidden="false"
                                    aria-label="Offer disclaimer"
                                    fontIcon="info"
                                    class="flex-none"></mat-icon>
                                <div class="details__banner-message">
                                    <span
                                        >Deal data is pre-populated from the current job details in the JobID linked to
                                        this offer and compared to the original job details when the candidate
                                        submitted.</span
                                    >
                                    <span>*RTO is captured from most recent Nova submittal snapshot.</span>
                                </div>
                            </div>
                        }

                        <mat-card class="details__info-card mb-4">
                            <mat-card-header>
                                <mat-card-title>Important Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="flex-col flex-1">
                                    <mat-form-field>
                                        <textarea
                                            matInput
                                            class="textarea-control"
                                            formControlName="otherDetails"
                                            data-qa-id="OtherDetailsText"></textarea>
                                        <mat-hint align="end"
                                            >{{ detailsFormGroup.controls.otherDetails.value?.length }}/1500
                                            characters</mat-hint
                                        >
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="mb-4">
                            <mat-card-header class="mb-2">
                                <mat-card-title>Internal Offer Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="details">
                                    @if (offerType === offerTypes.Agency) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Vendor</mat-label>
                                            <span data-qa-id="VendorNameView">{{ offerDetails?.vendorName }}</span>
                                        </div>
                                        <div class="details__item">
                                            <mat-label class="details__item--label">Vendor Contact</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <mat-select
                                                    formControlName="vendorContactId"
                                                    data-qa-id="VendorRateInput">
                                                    @for (option of vendorLookups?.contacts; track option.id) {
                                                        <mat-option [value]="option.id">
                                                            {{ option.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    }
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Candidate</mat-label>
                                        <div class="flex-row">
                                            <a
                                                class="nova__link"
                                                data-qa-id="CandidateView"
                                                target="_blank"
                                                rel="noopener"
                                                [routerLink]="[
                                                    '/recruiting/candidates/',
                                                    offerDetails?.candidateId,
                                                    'new-profile',
                                                    'about'
                                                ]"
                                                >{{ offerDetails?.candidateName }}</a
                                            >
                                            <span class="ml-1">({{ offerDetails?.candidateEmail }})</span>
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Contract Type</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select
                                                formControlName="contractTypeId"
                                                data-qa-id="ContractTypeSelect">
                                                @for (option of lookups?.contracts; track option.id) {
                                                    <mat-option [value]="option.id">{{ option.code }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    @if (offerType !== offerTypes.Agency) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Contract Status</mat-label>
                                            <span>{{ offerDetails.contractRequestStatus }}</span>
                                        </div>
                                    }
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Job ID</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="jobId"
                                                [matAutocomplete]="jobIdAuto"
                                                data-qa-id="JobIdInput"
                                                (change)="jobIdSelection($event)" />
                                            <mat-autocomplete
                                                #jobIdAuto="matAutocomplete"
                                                [displayWith]="displayJobIds"
                                                (optionSelected)="jobIdSelection($event)">
                                                @for (job of filteredJobIdOptions | async; track job) {
                                                    <mat-option [value]="job">{{ job }} </mat-option>
                                                }
                                            </mat-autocomplete>
                                            @if (isDifferent('jobId')) {
                                                <mat-hint class="diff-line"
                                                    >Recruiter Submittal:
                                                    <span class="diff-value">{{
                                                        snapshotData?.jobDetails?.jobId
                                                    }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Facility Rate</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="facilityRate"
                                                (keyup)="updateVendorRate()"
                                                data-qa-id="FacilityRateInput"
                                                (change)="calculateContractDates('facilityRateChanged')" />
                                            <span matTextPrefix>$</span>
                                            @if (isDifferent('facilityRate')) {
                                                <mat-hint class="diff-line"
                                                    >Recruiter Submittal:
                                                    <span class="diff-value"
                                                        >${{ snapshotData?.jobDetails?.billRate }}</span
                                                    ></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>
                                    @if (offerType !== offerTypes.Agency) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Doughboy</mat-label>
                                            <div class="flex-row">
                                                @if (offerDetails?.recruiterBonus) {
                                                    <span>{{ offerDetails?.recruiterBonus | currency }}</span>
                                                }
                                                <nova-recruiter-bonus
                                                    class="recruiter-bonus-icon"
                                                    [bonus]="offerDetails?.recruiterBonus"
                                                    data-qa-id="DoughboyText"></nova-recruiter-bonus>
                                            </div>
                                        </div>
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Target Margin</mat-label>
                                            <div class="flex-col">
                                                <span>{{ offerDetails.jobTargetMargin ?? 0 }}%</span>
                                                @if (isDifferent('targetMargin')) {
                                                    <span class="diff-line ml-0"
                                                        >Recruiter Submittal:
                                                        <span class="diff-value"
                                                            >{{ snapshotData?.jobDetails?.targetMargin ?? 0 }}%</span
                                                        ></span
                                                    >
                                                }
                                            </div>
                                        </div>
                                    } @else {
                                        <div class="details__item">
                                            <mat-label class="details__item--label">Vendor Rate</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <input
                                                    type="number"
                                                    matInput
                                                    formControlName="vendorRate"
                                                    data-qa-id="VendorRateInput" />
                                                <span matTextPrefix>$</span>
                                            </mat-form-field>
                                        </div>
                                    }

                                    @if (offerType === offerTypes.Direct) {
                                        <div class="details__item">
                                            <mat-label class="details__item--label">Aya Paid Bonus</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <input
                                                    type="number"
                                                    matInput
                                                    formControlName="ayaPaidBonus"
                                                    (keydown)="validateInput($event)"
                                                    data-qa-id="ayaPaidBonusInput"
                                                    min="0"
                                                    max="999999.99"
                                                />
                                                <span matTextPrefix>$</span>
                                                <mat-error>Please enter valid bonus amount.</mat-error>
                                                @if (isDifferent('ayaPaidBonus')) {
                                                    <mat-hint class="diff-line">Recruiter Submittal:
                                                        <span class="diff-value">${{ snapshotData?.jobDetails?.ayaPaidBonus }}</span></mat-hint>
                                                }
                                            </mat-form-field>
                                        </div>
                                    }

                                    @if (offerDetails?.isRemoteBooking !== null) {
                                        <div
                                            class="details__item details__gap items-center"
                                            data-qa-id="job-details-work-model">
                                            <mat-label class="details__item--label">Work Model</mat-label>
                                            <mat-radio-group
                                                formControlName="isRemoteBooking"
                                                name="isRemoteBooking"
                                                data-qa-id="job-details-work-model-radio">
                                                <mat-radio-button
                                                    class="nml-6"
                                                    [value]="false"
                                                    >Onsite</mat-radio-button
                                                >
                                                <mat-radio-button
                                                    class="ml-3"
                                                    [value]="true"
                                                    >Remote</mat-radio-button
                                                >
                                            </mat-radio-group>
                                        </div>
                                    }
                                    @if (offerDetails?.isPatientFacing !== null) {
                                        <div
                                            class="details__item details__gap"
                                            data-qa-id="job-details-work-type">
                                            <mat-label class="details__item--label">Work Type</mat-label>
                                            <span>{{
                                                offerDetails?.isPatientFacing ? 'Patient-Facing' : 'Non-Patient-Facing'
                                            }}</span>
                                        </div>
                                    }

                                    @if (offerType !== offerTypes.Agency) {
                                        <div class="details__item">
                                            <div class="flex-row details__item--label">
                                                <mat-label class="pipeline-label"
                                                    >Pipelines Request Instructions
                                                </mat-label>
                                                <mat-icon
                                                    class="pipeline-request-instruction-info-icon"
                                                    matTooltip="Use this field to specify what should be added to the contract - such as special rate details (holiday, RTO, OT), end date rules, or unique shift information for the traveler's contract"
                                                    >info</mat-icon
                                                >
                                            </div>
                                            <div class="flex-col flex-1">
                                                <mat-form-field>
                                                    <textarea
                                                        matInput
                                                        class="textarea-control"
                                                        formControlName="pipelineRequestInstructions"
                                                        data-qa-id="PipelineRequestInstructionsText"></textarea>
                                                    <mat-hint align="end"
                                                        >{{
                                                            detailsFormGroup.controls.pipelineRequestInstructions?.value
                                                                ?.length ?? 0
                                                        }}/500 characters</mat-hint
                                                    >
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <mat-card>
                            <mat-card-header class="mb-2">
                                <mat-card-title>Candidate Offer Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="details">
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Facility</mat-label>
                                        <div class="flex-row">
                                            <a
                                                class="nova__link"
                                                data-qa-id="FacilityView"
                                                target="_blank"
                                                rel="noopener"
                                                [routerLink]="[
                                                    '/accountmanagers/facilities/',
                                                    offerDetails?.facilityId,
                                                    'facility-profile'
                                                ]"
                                                >{{ offerDetails?.facilityName }}
                                            </a>
                                            @if (offerDetails?.facilityCity && offerDetails?.facilityState) {
                                                <span class="ml-1"
                                                    >({{ offerDetails?.facilityCity }},
                                                    {{ offerDetails?.facilityState }})</span
                                                >
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Position Type</mat-label>
                                        <span>{{ offerDetails?.positionType }}</span>
                                    </div>
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Unit</mat-label>
                                        @if (offerDetails?.unitDescriptionFormId) {
                                            <a
                                                class="nova__link"
                                                target="_blank"
                                                rel="noopener"
                                                (click)="openUnitFormUrl($event)"
                                                >{{ offerDetails?.unitName }}</a
                                            >
                                        } @else {
                                            <span>{{ offerDetails.unitName }}</span>
                                        }
                                    </div>
                                    @if (offerType === offerTypes.Agency) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Candidate Profession</mat-label>
                                            <span>{{ offerDetails?.candidateProfessionName }}</span>
                                        </div>
                                    }
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Job Profession</mat-label>
                                        <div
                                            [ngClass]="
                                                validateCandidateProfessionJobs ? 'flex-col gap-4' : 'flex-row gap-8'
                                            ">
                                            <span data-qa-id="ProfessionView">{{
                                                detailsFormGroup?.controls?.professionName?.value
                                            }}</span>
                                            <span class="diff-line diff-static ml-0">
                                                @if (validateCandidateProfessionJobs) {
                                                    Candidate Profession
                                                    <span class="diff-value">{{
                                                        offerDetails?.candidateProfessionName
                                                    }}</span>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Job Specialty</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select
                                                formControlName="expertiseId"
                                                (selectionChange)="checkRateUpdateFields('Expertise')"
                                                [disabled]="!detailsFormGroup?.controls?.professionId?.value"
                                                data-qa-id="ExpertiseSelect">
                                                @for (option of expertise; track option.id) {
                                                    <mat-option [value]="option.id">{{ option.name }}</mat-option>
                                                }
                                            </mat-select>
                                            @if (isDifferent('specialty')) {
                                                <mat-hint class="diff-line"
                                                    >Recruiter Submittal:
                                                    <span class="diff-value">{{
                                                        snapshotData?.jobDetails?.specialty
                                                    }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Payroll Workweek</mat-label>
                                        <span>{{ offerDetails.payrollWorkweek }}</span>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Contract Length</mat-label>
                                        <div class="contract-length-controls">
                                            <div class="flex-row">
                                                <mat-form-field class="details__item--control contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('weeksLengthChanged')"
                                                        formControlName="contractLength" />
                                                    <mat-error>Please enter valid Weeks Length.</mat-error>
                                                    @if (isDifferent('contractLength')) {
                                                        <mat-hint class="diff-line"
                                                            >Recruiter Submittal:
                                                            <span class="diff-value">{{
                                                                snapshotData?.jobDetails?.length
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                                <span class="control-suffix ml-1">Weeks</span>
                                            </div>
                                            <div class="flex-row">
                                                <mat-form-field class="details__item--control contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('daysLengthChanged')"
                                                        formControlName="contractLengthDays" />
                                                    <mat-error>Please enter valid Days Length.</mat-error>
                                                </mat-form-field>
                                                <span class="control-suffix ml-1">Days</span>
                                                @if (contractLengthDaysApprovalRequired) {
                                                    <mat-icon
                                                        class="info-icon"
                                                        [matTooltip]="contractLengthDaysInfoMessage"
                                                        >info</mat-icon
                                                    >
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Start*</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                matInput
                                                [matDatepicker]="picker"
                                                formControlName="startDate"
                                                (dateChange)="calculateContractDates('startDateChanged')"
                                                data-qa-id="StartDateInput" />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                            @if (detailsFormGroup.controls['startDate'].invalid) {
                                                <mat-error>Please enter valid start date.</mat-error>
                                            }
                                            @if (isDifferent('startDate')) {
                                                <mat-hint class="diff-line"
                                                    >Recruiter Submittal:
                                                    <span class="diff-value">{{
                                                        snapshotData?.jobDetails?.startDate | date: 'MM/dd/yyyy'
                                                    }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">End*</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                matInput
                                                [matDatepicker]="endPicker"
                                                formControlName="endDate"
                                                [min]="minEndDate"
                                                (dateChange)="calculateContractDates('endDateChanged')"
                                                data-qa-id="EndDateInput" />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="endPicker"></mat-datepicker-toggle>
                                            <mat-datepicker #endPicker></mat-datepicker>
                                            @if (detailsFormGroup.controls['endDate'].invalid) {
                                                <mat-error>Please enter valid end date.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">RTO</mat-label>
                                        <mat-checkbox
                                            class="nml-6"
                                            formControlName="hasRequestedTimeOff"
                                            data-qa-id="hasRequestedTimeOffCheckbox"></mat-checkbox>
                                    </div>
                                    @if (detailsFormGroup.controls.hasRequestedTimeOff.value) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">RTO Dates</mat-label>
                                            <div class="flex-col gap-4">
                                                <div class="flex-row">
                                                    <div class="rto-container">
                                                        <div class="calendar-control">
                                                            <div class="days">
                                                                <span>{{ daysRequested }}</span>
                                                            </div>
                                                            <button
                                                                class="rto-btn"
                                                                mat-icon-button
                                                                [matMenuTriggerFor]="appMenu">
                                                                <mat-icon>event</mat-icon>
                                                            </button>
                                                        </div>
                                                        <mat-menu
                                                            #appMenu="matMenu"
                                                            class="drop-calendar">
                                                            <div (click)="$event.stopPropagation()">
                                                                <mat-calendar
                                                                    #calendar
                                                                    class="mat-calendar"
                                                                    [dateClass]="dateClass()"
                                                                    [maxDate]="maxDate"
                                                                    [minDate]="minDate"
                                                                    (selectedChange)="
                                                                        dateChanged($event)
                                                                    "></mat-calendar>
                                                            </div>
                                                        </mat-menu>
                                                        <a
                                                            class="nova-link rto-clear__btn"
                                                            [class.disabled]="daysSelected.length ? false : true"
                                                            (click)="clearDates()"
                                                            #clearCalendarTrigger="matMenuTrigger"
                                                            [matMenuTriggerFor]="appMenu"
                                                            >Clear</a
                                                        >
                                                    </div>
                                                </div>
                                                @if (isDifferent('rto')) {
                                                    <span class="diff-line ml-0"
                                                        >Recruiter Submittal:
                                                        <span class="diff-value flex-i">
                                                            @for (date of snapshotRtoDisplay; track date) {
                                                                {{ date }}<br />
                                                            }</span
                                                    ></span>
                                                }
                                                @if (showRTOAlertOnStartEndDates) {
                                                    <div class="offer-rto-warning">
                                                        <nova-rto-warning-message
                                                            [enabled]="showRTOAlertOnStartEndDates">
                                                        </nova-rto-warning-message>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div class="details__item">
                                            <mat-label class="details__item--label">RTO Approval</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <mat-select
                                                    formControlName="rtoApprovalStatus"
                                                    data-qa-id="RTOApprovalStatusSelect">
                                                    <mat-option [value]="1">Approved</mat-option>
                                                    <mat-option [value]="2">Pending Approval</mat-option>
                                                    <mat-option [value]="3">Not Approved</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    }
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Type*</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select
                                                formControlName="shiftTypeId"
                                                data-qa-id="ShiftTypeSelect">
                                                @for (option of lookups?.shiftTypes; track option.key) {
                                                    <mat-option [value]="option.key">{{ option.value }}</mat-option>
                                                }
                                            </mat-select>
                                            @if (hasError('shiftTypeId', 'required')) {
                                                <mat-error>Shift Type is required</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Number of Shifts*</mat-label>
                                        <div class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="shifts"
                                                    data-qa-id="NumberShiftsSelect"
                                                    (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                    @for (num of shiftValues; track num) {
                                                        <mat-option [value]="num">{{ num }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shifts', 'required')) {
                                                    <mat-error>Number of Shifts is required</mat-error>
                                                }
                                                @if (isDifferent('shifts')) {
                                                    <mat-hint class="diff-line"
                                                        >Recruiter Submittal:
                                                        <span class="diff-value">{{
                                                            snapshotData?.jobDetails?.shiftDetails?.shifts
                                                        }}</span></mat-hint
                                                    >
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select
                                                        formControlName="shiftsAlt"
                                                        data-qa-id="NumberShiftsAltSelect">
                                                        @for (num of shiftValues; track num) {
                                                            <mat-option [value]="num">{{ num }}</mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('shiftsAlt', 'required')) {
                                                        <mat-error>Number of Alt Shifts is required</mat-error>
                                                    }
                                                    @if (isDifferent('shiftsAlt')) {
                                                        <mat-hint class="diff-line"
                                                            >Recruiter Submittal:
                                                            <span class="diff-value">{{
                                                                snapshotData?.jobDetails?.shiftDetails?.shiftsAlt
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Length in Hours*</mat-label>
                                        <div class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="hours"
                                                    (selectionChange)="checkRateUpdateFields('Shift Length')"
                                                    data-qa-id="ShiftLengthSelect">
                                                    @for (length of hoursValue; track length) {
                                                        <mat-option [value]="length">{{ length }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('hours', 'required')) {
                                                    <mat-error>Shift Length is required</mat-error>
                                                }
                                                @if (isDifferent('shiftLength')) {
                                                    <mat-hint class="diff-line"
                                                        >Recruiter Submittal:
                                                        <span class="diff-value">{{
                                                            snapshotData?.jobDetails?.shiftDetails?.hours
                                                        }}</span></mat-hint
                                                    >
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select
                                                        formControlName="hoursAlt"
                                                        (selectionChange)="onShiftLengthAltSelected()"
                                                        data-qa-id="ShiftAltLengthSelect">
                                                        @for (length of hoursValue; track length) {
                                                            <mat-option [value]="length">{{ length }}</mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('hoursAlt', 'required')) {
                                                        <mat-error>Alt Shift Length is required</mat-error>
                                                    }
                                                    @if (isDifferent('shiftAltLength')) {
                                                        <mat-hint class="diff-line"
                                                            >Recruiter Submittal:
                                                            <span class="diff-value">{{
                                                                snapshotData?.jobDetails?.shiftDetails?.hoursAlt
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Time of Day*</mat-label>
                                        <div class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="shiftTimeOfDayId"
                                                    (selectionChange)="checkRateUpdateFields('Shift Time of Day')"
                                                    data-qa-id="ShiftTimeSelect">
                                                    @for (option of lookups?.shiftTimes; track option.key) {
                                                        <mat-option [value]="option.key">{{ option.value }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shiftTimeOfDayId', 'required')) {
                                                    <mat-error>Shift Time of Day is required</mat-error>
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift || isRotatingShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select
                                                        formControlName="shiftAltTimeOfDayId"
                                                        data-qa-id="ShiftAltTimeSelect">
                                                        @for (option of lookups?.shiftTimes; track option.key) {
                                                            <mat-option [value]="option.key">{{
                                                                option.value
                                                            }}</mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('shiftAltTimeOfDayId', 'required')) {
                                                        <mat-error class="extended-error">Alt Shift Time of Day is required</mat-error>
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Time (optional)</mat-label>
                                        <div
                                            class="flex-row details__item--control"
                                            [class.gap-16]="viewAltShift || isRotatingShift">
                                            <div class="flex-col flex-1 gap-8">
                                                <div class="flex-col gap-8">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">Start</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftTimeStart"
                                                            (valueChange)="onTimeStartChanged($event)"
                                                            format="HH:mm"
                                                            data-qa-id="ShiftStartTimepicker">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftTimeStart')) {
                                                                Recruiter Submittal:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="flex-col gap-8">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">End</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftTimeEnd"
                                                            (valueChange)="onTimeEndChanged($event)"
                                                            format="HH:mm"
                                                            data-qa-id="ShiftEndTimepicker">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftTimeEnd')) {
                                                                Recruiter Submittal:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftToH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftToM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            @if (viewAltShift || isRotatingShift) {
                                                <div class="flex-col flex-1 gap-8">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">Start</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftAltTimeStart"
                                                            (valueChange)="onAltTimeStartChanged($event)"
                                                            format="HH:mm"
                                                            data-qa-id="ShiftAltStartTimepicker">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftAltTimeStart')) {
                                                                Recruiter Submittal:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftAltH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftAltM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">End</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftAltTimeEnd"
                                                            (valueChange)="onAltTimeEndChanged($event)"
                                                            format="HH:mm"
                                                            data-qa-id="ShiftAltEndTimepicker">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftAltTimeEnd')) {
                                                                Recruiter Submittal:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftAltToH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData?.jobDetails?.shiftDetails
                                                                            ?.shiftAltToM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Details</mat-label>
                                        <div class="flex-col flex-1">
                                            <mat-form-field>
                                                <textarea
                                                    matInput
                                                    class="textarea-control"
                                                    formControlName="shiftDetails"
                                                    data-qa-id="ShiftDetailsText"></textarea>
                                                <mat-hint
                                                    class="textarea-control-hint"
                                                    align="end"
                                                    >{{ detailsFormGroup.controls.shiftDetails.value?.length }}/1500
                                                    characters</mat-hint
                                                >
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </form>
                </div>
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="loader"></ng-container>
        }
    }
</div>

<ng-template #loader>
    <mat-card>
        <mat-card-content>
            <div class="loading-container">
                <mat-progress-spinner
                    mode="indeterminate"
                    diameter="96"></mat-progress-spinner>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
